export * from './testkit';
export * from './dto';
export var agentStatsUrl = '/agent/stats';
export var createCallCenterDashboardApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/dashboard/callcenter");
    return {
        getTableData: function (dashboardDto) { return http.post("".concat(url), dashboardDto); },
        getDashboardOverview: function (callcenterDashboardOverviewDto) { return http.post("".concat(url, "/overview"), callcenterDashboardOverviewDto); },
        getAgentStats: function (callCenterDashboardBaseDto) { return http.post("".concat(url).concat(agentStatsUrl), callCenterDashboardBaseDto); },
        getAgentStatsNew: function (callCenterDashboardBaseDto) { return http.post("".concat(url).concat(agentStatsUrl, "/new"), callCenterDashboardBaseDto); },
    };
};
//# sourceMappingURL=index.js.map